var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('center',[_c('img',{attrs:{"src":require("@/assets/loading.gif"),"width":"40"}})])}
var staticRenderFns = []

export { render, staticRenderFns }